/**
 * @generated SignedSource<<f93fe408ca7864d5ef828176f85e97cf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FormulaSetHistoryDialog_formulaSetHistory$data = {
  readonly created: any;
  readonly createdBy: {
    readonly name: string;
    readonly picture: string | null;
  };
  readonly difference: {
    readonly " $fragmentSpreads": FragmentRefs<"FormulaSetDifferenceItemList_formulaSetDifference">;
  } | null;
  readonly " $fragmentType": "FormulaSetHistoryDialog_formulaSetHistory";
};
export type FormulaSetHistoryDialog_formulaSetHistory$key = {
  readonly " $data"?: FormulaSetHistoryDialog_formulaSetHistory$data;
  readonly " $fragmentSpreads": FragmentRefs<"FormulaSetHistoryDialog_formulaSetHistory">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FormulaSetHistoryDialog_formulaSetHistory",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "createdBy",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "picture",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "difference",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormulaSetDifferenceItemList_formulaSetDifference"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FormulaSetHistory",
  "abstractKey": null
};

(node as any).hash = "750b9b232b0c4cea05e71afffe86b8da";

export default node;
